import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
/**
 * Colors_T31.jsx — Template 31 Modern Luxury Design
 * Palette: Midnight Navy · Indigo · Cyan · Amber
 */

export const mapB2CTenantToLanding = (tenantData) => {
  const theme  = tenantData?.theme  || {};
  const topBar = tenantData?.topBar || {};
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero   = tenantData?.hero   || {};

  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:   tenantData?.companyId,
    logoUrl:     getLocalLogoUrl(tenantData?.domain),
    brandName:   tenantData?.branding?.brandName  || 'Travel Agency',
    email:       tenantData?.branding?.email      || 'support@agency.com',
    phones:      Array.isArray(tenantData?.branding?.phones)
                   ? tenantData?.branding?.phones[0]
                   : tenantData?.branding?.phones  || '9128341203',
    whatsapp:    tenantData?.branding?.whatsapp   || '9128341203',
    socials:     tenantData?.branding?.socials    || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1: theme.themeColor1 || theme.themecolor1,
    themeColor2: theme.themeColor2 || theme.themecolor2,
    themeColor3: theme.themeColor3 || theme.themecolor3,
    themeColor4: theme.themeColor4 || theme.themecolor4,
    themeColor5: theme.themeColor5 || theme.themecolor5,

    topBarBg:   topBar.bgColor   || theme.themeColor1 || theme.themecolor1,
    topBarText: topBar.textColor || '#94A3B8',

    headerBg:   header.bgColor   || theme.themeColor3 || theme.themecolor3 || '#1E293B',
    headerText: header.textColor || '#F1F5F9',

    footerBg:   footer.bgColor   || theme.themeColor2 || theme.themecolor2 || '#0F172A',
    footerText: footer.textColor || '#94A3B8',

    heroData: {
      flights: {
        title:     hero.flights?.title     || 'Search & Book Flights.',
        subTitle:  hero.flights?.subTitle  || 'Compare 500+ airlines and find the best deals in seconds.',
        textColor: hero.flights?.textColor || '#FFFFFF',
        bgImage:   hero.flights?.bgImage   || 'https://images.unsplash.com/photo-1436491865332-7a61a109c0f3?q=80&w=1600',
      },
      hotels: {
        title:     hero.hotels?.title     || 'Find Your Perfect Stay.',
        subTitle:  hero.hotels?.subTitle  || 'Handpicked hotels from budget to luxury across the globe.',
        textColor: hero.hotels?.textColor || '#FFFFFF',
        bgImage:   hero.hotels?.bgImage   || 'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?q=80&w=1600',
      },
      holidays: {
        title:     hero.holidays?.title     || 'Discover Your Dream Trip.',
        subTitle:  hero.holidays?.subTitle  || 'Curated holiday packages for every kind of traveller.',
        textColor: hero.holidays?.textColor || '#FFFFFF',
        bgImage:   hero.holidays?.bgImage   || 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=1600',
      },
      sightseeing: {
        title:     hero.sightseeing?.title     || 'Explore the World\'s Wonders.',
        subTitle:  hero.sightseeing?.subTitle  || 'Guided tours, activities & unforgettable experiences await.',
        textColor: hero.sightseeing?.textColor || '#FFFFFF',
        bgImage:   hero.sightseeing?.bgImage   || 'https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=1600',
      },
    },
  };
};

export const getB2CColors_T31 = (landingData) => {
  const c1 = landingData.themeColor1 || '#6366F1'; // Indigo — modern primary
  return {
    theme1: c1,
    theme2: landingData.footerBg   || '#0F172A', // Midnight navy
    theme3: landingData.headerBg   || '#1E293B', // Dark slate
    theme4: landingData.themeColor4 || '#EEF2FF', // Light indigo surface
    theme5: landingData.themeColor5 || '#FFFFFF',

    headerText: landingData.headerText || '#F1F5F9',
    footerText: landingData.footerText || '#94A3B8',
    topBarBg:   landingData.topBarBg   || '#0A0F1E', // Near-black top bar
    topBarText: landingData.topBarText || '#94A3B8',
  };
};
